import React, { useRef } from 'react';
import UploadFileIcon from '@cp/src/assets/icons/UploadFileIcon';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../Enach.module.scss';
import cx from 'classnames';
export const CustomFileUploadComponent = (
  handleUploadClick: (e: React.ChangeEvent<any>) => void,
  disabled?: boolean,
  uploadedFileType?: string,
  clickstreamEvent?: { name: string; description: string },
  supportedFile?: string,
  textClassnameContainer?: string
) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);
  return (
    <div
      className={`flex flex-col justify-evenly items-center ${
        disabled ? 'opacity-60 pointer-events-none' : 'opacity-100 pointer-events-auto'
      }`}
    >
      <UploadFileIcon />
      <input
        id="fileUpload"
        type="file"
        accept=".csv"
        ref={hiddenFileInput}
        style={{ display: 'none' }}
      />
      <div
        className="text-sm text-[--blue-base] font-medium cursor-pointer mt-1"
        onClick={e => {
          if (clickstreamEvent) {
            addClickstreamEvent(clickstreamEvent, {
              uploadedFileType
            });
          }
          handleUploadClick(e);
        }}
      >
        Click to Upload
        <span className="text-[--grayscale-content-2]"> or drag and drop here</span>
      </div>
      <div className={cx(styles.text1Wrapper)}>
        <Typography variant={'p5'} className={cx(styles.text1, textClassnameContainer)}>
          Accepted file type {supportedFile}
        </Typography>
      </div>
    </div>
  );
};
